(() => {
  const root = document.getElementById('tl-signup');
  if (!root || window.Shopify?.designMode) return;
  const launcher = root.querySelector('.tl-signup-launcher');
  const dialog = root.querySelector('dialog');
  const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  let subscribed = root.dataset.subscribed === 'true' || read('tl-subscribed') === 'true';
  let dismissed = false;
  let lastActivity = Date.now();
  const started = Date.now();
  const visible = (el) => {
    const r = el.getBoundingClientRect();
    const style = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
  };
  const blocked = () => {
    if (document.hidden || /\/(cart|checkout|account|challenge)(\/|$)/.test(location.pathname)) return true;
    if (document.activeElement?.matches('input,textarea,select,[contenteditable=true]')) return true;
    if ([...document.querySelectorAll('dialog[open],header details[open],header [aria-expanded=true],[role=dialog][aria-modal=true],footer,.tl-newsletter,[data-stuck=true]')].some(visible)) return true;
    // Keep purchase and interactive controls clear without suppressing the invitation over ordinary page content.
    for (const [x,y] of [[30,innerHeight-38],[115,innerHeight-38],[190,innerHeight-38]]) {
      const elements = document.elementsFromPoint(x,y).filter(el => !root.contains(el));
      if (elements.some(el => el.matches('a,button,input,select,label') || el.closest('variant-picker,product-form,sticky-add-to-cart'))) return true;
    }
    return false;
  };
  const update = () => {
    const engaged = Date.now() - started > 5000;
    launcher.hidden = subscribed || dismissed || !engaged || Date.now() - lastActivity < 1000 || dialog.open || blocked();
  };
  const dismiss = () => { dismissed = true; launcher.hidden = true; };
  root.querySelector('[data-signup-dismiss]').addEventListener('click', dismiss);
  document.querySelectorAll('[data-signup-open]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); launcher.hidden = true; dialog.showModal(); }));
  root.querySelector('[data-signup-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { lastActivity = Date.now(); update(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  for (const event of ['pointerdown','keydown','change','focusin']) {
    window.addEventListener(event, (e) => { if (root.contains(e.target)) return; lastActivity = Date.now(); update(); }, {passive:true});
  }
  for (const event of ['scroll', 'resize']) window.addEventListener(event, update, { passive: true });
  document.addEventListener('cart:update', () => { lastActivity = Date.now() + 12000; update(); });
  const result = root.querySelector('[data-signup-result]');
  if (result) {
    if (result.dataset.signupResult === 'success') { subscribed = true; write('tl-subscribed', 'true'); }
    dialog.showModal();
  }
  setInterval(update, 500);
  update();
})();
